module.exports = __webpack_public_path__ + "img/client8.96b18c65.png";